import { jsxs as a, jsx as n } from "react/jsx-runtime";
import { c as _ } from "../../../clsx-OuTLNxxd.js";
import { I as t } from "../../../icon-DkgzfU3h.js";
import "../icon/iconsList.js";
const m = "_callout_1opdu_29", u = "_link_1opdu_45", o = {
  callout: m,
  "is-small": "_is-small_1opdu_40",
  link: u,
  "is-medium": "_is-medium_1opdu_49",
  "is-info": "_is-info_1opdu_53",
  "is-warning": "_is-warning_1opdu_56",
  "is-success": "_is-success_1opdu_59",
  "is-error": "_is-error_1opdu_62",
  "content-container": "_content-container_1opdu_65",
  "dialog-overlay-show": "_dialog-overlay-show_1opdu_1",
  "dialog-content-show": "_dialog-content-show_1opdu_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1opdu_1"
}, s = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  }
}, d = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error"
}, p = {
  small: "is-small",
  medium: "is-medium"
};
function h({ status: i = "info", size: c = "medium", children: r, hasIcon: e = !1 }) {
  const l = _(o.callout, o[d[i]], o[p[c]]);
  return /* @__PURE__ */ a("div", { className: l, children: [
    e && /* @__PURE__ */ n(t, { name: s[i].name, color: s[i].color, size: "2xl" }),
    /* @__PURE__ */ n("div", { className: o["content-container"], children: r })
  ] });
}
export {
  h as Callout
};
